import * as tslib_1 from "tslib";
import { ItemContainer } from './item_container';
var Collepse = /** @class */ (function (_super) {
    tslib_1.__extends(Collepse, _super);
    function Collepse(param) {
        return _super.call(this, param) || this;
    }
    Collepse.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Collepse" });
    };
    Collepse.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Collepse;
}(ItemContainer));
export { Collepse };
//# sourceMappingURL=collepse.js.map